export const siteDate = "2026.09.12";
export const siteWeekday = "星期六";

export const siteTickerItems = [
  "黑料福利专区今日新增 128 条精选内容，热度榜已同步刷新",
  "黑料福利入口完成本周通道巡检，各专区均可正常直达",
  "热度榜 · 话题盘点栏目上线「本周十大焦点」合集",
  "黑料福利地址聚合页更新，一键直达各分类板块",
  "编辑部精选：三个值得反复回看的深度盘点专题",
  "黑料福利导航新增「现场直击」专区，内容粒度更细",
];

export const navCategories = [
  { id: "focus", label: "焦点速览", count: 42 },
  { id: "topic", label: "话题盘点", count: 36 },
  { id: "rank", label: "热度榜单", count: 20 },
  { id: "people", label: "人物动态", count: 58 },
  { id: "scene", label: "现场直击", count: 27 },
  { id: "buzz", label: "网友热议", count: 91 },
  { id: "archive", label: "历史归档", count: 314 },
  { id: "entry", label: "专区入口", count: 16 },
];

export const mastheadStat = {
  updated: 128,
  channels: 16,
};

export const leadStory = {
  tag: "今日头条",
  title: "话题盘点周报：多平台热点同频，黑料福利专区入口一页直达",
  summary:
    "本期把散落在各处的讨论重新编排成一条清晰的时间线：从话题起点、热度爬升到节点复盘，逐一标注来源与时间。黑料福利导航把入口、地址与板块集中在一页，省去反复搜索的成本，让浏览与查找都更利落。",
  author: "黑料福利编辑部",
  time: "09-12 09:30",
  heat: "9.8 万",
  comments: 326,
};

export const heroAside = {
  kicker: "正在更新",
  title: "跨平台对照合集：同一事件的三种叙事版本",
  meta: "专题 · 24 条内容 · 09-12 更新",
};

export const briefStream = [
  {
    id: "b1",
    tag: "焦点",
    title: "话题起点回看：一条讨论如何在 24 小时内冲上热榜",
    summary: "从最早的一条留言到被反复转述的金句，完整还原热度爬升的每一步。",
    time: "09-12 08:40",
    heat: "7.2 万",
  },
  {
    id: "b2",
    tag: "盘点",
    title: "本周五个高频关键词，串起整个专区的讨论走向",
    summary: "关键词出现的频次与时间点，比单条内容更能说明话题重心在哪里。",
    time: "09-12 08:05",
    heat: "5.6 万",
  },
  {
    id: "b3",
    tag: "人物",
    title: "当事人回应之后，评论区风向出现明显拐点",
    summary: "回应的措辞、发布的时点与后续动作，共同决定了舆论的下一步。",
    time: "09-11 22:18",
    heat: "6.9 万",
  },
  {
    id: "b4",
    tag: "现场",
    title: "现场直击：三处细节被反复截图，成为讨论焦点",
    summary: "细节往往比结论更有传播力，这里把被引用最多的三处单独拎出来。",
    time: "09-11 20:52",
    heat: "4.4 万",
  },
  {
    id: "b5",
    tag: "热议",
    title: "热议区高赞回答整理，观点分成两大阵营",
    summary: "高赞不等于正确，但一定代表多数人的关注点，值得逐条对照。",
    time: "09-11 19:30",
    heat: "5.1 万",
  },
  {
    id: "b6",
    tag: "归档",
    title: "历史归档上新：相似话题在去年的走向与结局",
    summary: "把去年同类话题拉出来对照，很多争论其实早就有了参考答案。",
    time: "09-11 17:04",
    heat: "3.8 万",
  },
  {
    id: "b7",
    tag: "入口",
    title: "黑料福利入口通道巡检完成，各专区均可直达",
    summary: "本次巡检覆盖全部导航通道，入口、地址与板块状态一次看清。",
    time: "09-11 15:26",
    heat: "3.2 万",
  },
  {
    id: "b8",
    tag: "编辑",
    title: "编辑手记：为什么我们坚持给每条内容标注来源与时间",
    summary: "标注来源不是为了显得严谨，而是为了让读者能自己判断。",
    time: "09-11 14:10",
    heat: "2.7 万",
  },
];

export const hotRanking = [
  { rank: 1, tag: "焦点", title: "跨平台话题同频：同一事件三种叙事版本对照", heat: 98, trend: "up", change: "+12%" },
  { rank: 2, tag: "人物", title: "当事人深夜发文，评论区两小时破万", heat: 94, trend: "up", change: "+9%" },
  { rank: 3, tag: "现场", title: "盘点视频二次传播，关键帧被单独截图", heat: 90, trend: "up", change: "+6%" },
  { rank: 4, tag: "热议", title: "高赞回答阵营分化，理性讨论占比回升", heat: 85, trend: "flat", change: "0%" },
  { rank: 5, tag: "归档", title: "旧话题被重新挖出，时间线出现反转", heat: 79, trend: "up", change: "+4%" },
  { rank: 6, tag: "入口", title: "专区入口访问量周环比上涨，导航页受关注", heat: 74, trend: "up", change: "+3%" },
  { rank: 7, tag: "盘点", title: "关键词频次统计出炉，前五名变动明显", heat: 68, trend: "down", change: "-2%" },
  { rank: 8, tag: "焦点", title: "一条留言引发的连锁反应完整复盘", heat: 61, trend: "flat", change: "0%" },
  { rank: 9, tag: "现场", title: "现场素材补档，两处细节首次公开", heat: 55, trend: "up", change: "+2%" },
  { rank: 10, tag: "编辑", title: "编辑部答疑：内容标注规则一次说清", heat: 48, trend: "down", change: "-1%" },
];

export const entryNav = [
  { id: "e1", icon: "ri-flashlight-line", name: "焦点速览专区", desc: "实时聚合同期讨论度最高的焦点内容", count: 42 },
  { id: "e2", icon: "ri-list-check-2", name: "话题盘点专区", desc: "按主题归类，一条线看完来龙去脉", count: 36 },
  { id: "e3", icon: "ri-fire-line", name: "热度榜单专区", desc: "按热度排序，榜单每十分钟刷新一次", count: 20 },
  { id: "e4", icon: "ri-user-star-line", name: "人物动态专区", desc: "相关人物的公开发言与后续动作", count: 58 },
  { id: "e5", icon: "ri-camera-lens-line", name: "现场直击专区", desc: "一手素材与细节截图集中归档", count: 27 },
  { id: "e6", icon: "ri-chat-smile-2-line", name: "网友热议专区", desc: "高赞回答与观点碰撞的讨论现场", count: 91 },
  { id: "e7", icon: "ri-archive-2-line", name: "历史归档专区", desc: "往期话题的走向与结局对照", count: 314 },
  { id: "e8", icon: "ri-compass-3-line", name: "入口导航专区", desc: "黑料福利入口、地址与板块总览", count: 16 },
];

export const topicPicks = [
  {
    id: "t1",
    tag: "专题",
    title: "同一个话题，三种叙事：跨平台对照合集",
    desc: "把不同平台对同一事件的描述并排放在一起，差异一眼可见。",
    count: 24,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20artwork%20of%20layered%20geometric%20shapes%20and%20torn%20paper%20collage%2C%20deep%20crimson%20and%20soft%20blush%20tones%20on%20warm%20cream%20background%2C%20subtle%20halftone%20grain%20texture%2C%20modern%20magazine%20art%20direction%2C%20no%20text%2C%20wide%20balanced%20composition%2C%20harmonious%20warm%20palette&width=1000&height=700&seq=hl-topic-01&orientation=landscape",
  },
  {
    id: "t2",
    tag: "榜单",
    title: "本周热度 Top10 复盘：它们凭什么上榜",
    desc: "逐条拆解上榜原因，从时间点到传播路径完整还原。",
    count: 10,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20artwork%20of%20stacked%20bar%20shapes%20and%20risograph%20textures%20in%20warm%20amber%2C%20gold%20and%20honey%20tones%20on%20a%20cream%20canvas%2C%20subtle%20halftone%20grain%2C%20modern%20magazine%20art%20direction%2C%20no%20text%2C%20wide%20balanced%20composition%2C%20cohesive%20warm%20palette&width=1000&height=700&seq=hl-topic-02&orientation=landscape",
  },
  {
    id: "t3",
    tag: "归档",
    title: "似曾相识：去年同类话题的结局备忘",
    desc: "把历史归档里的相似案例抽出来，给当下的讨论做参照。",
    count: 18,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20artwork%20of%20overlapping%20archival%20cards%20and%20concentric%20line%20textures%20in%20muted%20sage%20green%20and%20soft%20stone%20tones%20on%20a%20warm%20cream%20background%2C%20subtle%20paper%20grain%2C%20modern%20magazine%20art%20direction%2C%20no%20text%2C%20wide%20balanced%20composition&width=1000&height=700&seq=hl-topic-03&orientation=landscape",
  },
];

export const stats = [
  { id: "s1", value: "1,286", label: "今日新增内容" },
  { id: "s2", value: "16", label: "专区导航通道" },
  { id: "s3", value: "9.8 万", label: "榜单最高热度" },
  { id: "s4", value: "314", label: "历史归档条目" },
];

export const editorPicks = [
  { id: "p1", title: "为什么我们把「来源」放在标题下面", note: "标注来源让读者能自行判断，而不是被结论牵着走。", date: "09-11" },
  { id: "p2", title: "热度榜不等于真相榜", note: "热度只说明关注度，不说明对错，这是两件事。", date: "09-10" },
  { id: "p3", title: "入口导航的一次小改造", note: "把入口、地址和板块合并到一页，少一次搜索。", date: "09-09" },
  { id: "p4", title: "关于评论区，我们做了三件小事", note: "更清晰的排序、更完整的上下文、更少的断章取义。", date: "09-08" },
  { id: "p5", title: "归档的价值在于可对照", note: "历史不是负担，是理解当下的最快路径。", date: "09-07" },
];

export const footerColumns = [
  {
    id: "f1",
    title: "热门板块",
    links: ["焦点速览", "话题盘点", "热度榜单", "人物动态", "现场直击"],
  },
  {
    id: "f2",
    title: "专区导航",
    links: ["黑料福利专区", "黑料福利入口", "黑料福利导航", "黑料福利地址", "历史归档"],
  },
  {
    id: "f3",
    title: "关于本站",
    links: ["编辑准则", "内容标注说明", "通道巡检记录", "更新日志", "联系编辑部"],
  },
];